module.exports = __webpack_public_path__ + "static/media/20180529_184050.bb0e4230.jpg";